<!--
 * @Author:
 * @Description: 通用信息提示组件，支持自定义文案、样式和插槽
 * @Date: 2025-04-01 10:04:15
 * @LastEditors: Please set LastEditors
 * @FilePath: /rhcn-merchant-web/src/components/common/common-info-description/index.vue
-->
<template>
  <div class="common-info-tooltips" :style="customStyle">
    <template v-if="!$slots.default">
      <!-- TODO: 图标样式以后不建议接受png图标，建议接受svg图标 -->
      <img class="iconfont" src="~@/assets/image/common/icon-info.png" alt="" srcset="">
      <template v-if="Array.isArray(text)">
        <div class="common-info-tooltips-list">
          <p v-for="(item, index) in text" :key="index" class="common-info-tooltips-text" :style="textStyle">
            {{ item }}
          </p>
        </div>
      </template>
      <template v-else>
        <span class="common-info-tooltips-text" :style="textStyle">
          {{ text }}
        </span>
      </template>
    </template>
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'CommonInfoDescription',
  props: {
    // 自定义文案，支持字符串或字符串数组
    text: {
      type: [String, Array],
      default: '',
    },
    // 自定义整体样式
    customStyle: {
      type: Object,
      default: () => ({}),
    },
    // 自定义图标样式
    iconStyle: {
      type: Object,
      default: () => ({}),
    },
    // 自定义文本样式
    textStyle: {
      type: Object,
      default: () => ({}),
    },
  },
});
</script>

<style lang="scss" scoped>
@import './style/index.scss';

.common-info-tooltips-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
</style>
